import { useEffect, useRef } from "react";
import { trackGoal } from "@/utils/analytics";

const VISIBILITY_THRESHOLD = 0.5;

export const useSectionVisibility = (sectionIds: string[]) => {
  const trackedSections = useRef<Set<string>>(new Set());

  useEffect(() => {
    if (typeof window === "undefined" || !window.IntersectionObserver) return;

    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting && entry.intersectionRatio >= VISIBILITY_THRESHOLD) {
            const sectionId = entry.target.id;

            if (sectionId && !trackedSections.current.has(sectionId)) {
              trackedSections.current.add(sectionId);
              trackGoal(`view_${sectionId}`, {
                section: sectionId,
                visibility: Math.round(entry.intersectionRatio * 100),
              });
            }
          }
        }
      },
      {
        threshold: [VISIBILITY_THRESHOLD],
        rootMargin: "0px",
      },
    );

    for (const sectionId of sectionIds) {
      const element = document.getElementById(sectionId);
      if (element) {
        observer.observe(element);
      }
    }

    return () => {
      observer.disconnect();
    };
  }, [sectionIds]);
};
